<template>
  <div>
    <CButton :to="{name: 'register'}" color="primary" v-translate block>
      Create account
    </CButton>

    <div class="text-center info">
      <span v-translate>otherwise</span>
    </div>

    <SocialLogin can-register/>

    <AlreadyHaveAccount/>
  </div>
</template>

<script>
import SocialLogin from "@/domain/login/components/SocialLogin.vue";
import AlreadyHaveAccount from "@/domain/login/components/AlreadyHaveAccount.vue";

export default {
  name: 'AcceptNotLogged',
  components: {AlreadyHaveAccount, SocialLogin},
  computed: {},
}
</script>
